import { render, staticRenderFns } from "./HeaderSimple.vue?vue&type=template&id=6684af81&"
import script from "./HeaderSimple.vue?vue&type=script&lang=js&"
export * from "./HeaderSimple.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports